import type { GameState } from '../core/GameState';
import type { EventBus } from '../core/EventBus';

export class MonitorSystem {
  private state: GameState;
  private events: EventBus;
  preventCrash = false; // Tutorial mode: cap drift at 80%, no crash

  constructor(state: GameState, events: EventBus) {
    this.state = state;
    this.events = events;
  }

  update(dt: number): void {
    if (this.state.phase !== 'playing') return;

    let anyAbove75 = false;

    for (const agent of this.state.agents) {
      if (agent.status !== 'working') continue;

      // Accumulate drift
      agent.drift += agent.driftSpeed * dt;

      if (this.preventCrash) {
        agent.drift = Math.min(agent.drift, 0.8);
      } else {
        agent.drift = Math.min(agent.drift, 1.0);
      }

      // Track VS KPI — any agent above 75%
      if (agent.drift > 0.75) {
        anyAbove75 = true;
      }

      // Agent crash at 100% (only if crashes allowed)
      if (!this.preventCrash && agent.drift >= 1.0) {
        agent.status = 'crashed';
        this.events.emit('agent:crashed', { agentId: agent.id });
      }
    }

    if (anyAbove75) {
      this.state.totalTimeAbove75Drift += dt;
    }
    this.state.updateVS();
  }
}
